export * from './mb-occ-wishlist.adapter'
